(function() {
  function bind(form) {
    if (!form || form.dataset.bunkersBound) return;
    form.dataset.bunkersBound = '1';
    var input = form.querySelector('input[type="email"]');
    var statusEl = form.querySelector('.bunkers__status');
    var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    form.addEventListener('submit', function(e) {
      if (!input || emailRe.test(input.value.trim())) return;
      e.preventDefault();
      if (statusEl) {
        statusEl.classList.remove('success');
        statusEl.classList.add('error');
        statusEl.innerHTML = '<p>Please enter a valid email address.</p>';
      }
      input.focus();
    });
  }
  function init() {
    document.querySelectorAll('.bunkers__access').forEach(bind);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
